import { render, staticRenderFns } from "./signCard.vue?vue&type=template&id=1d9b3f20&scoped=true&"
import script from "./signCard.vue?vue&type=script&lang=js&"
export * from "./signCard.vue?vue&type=script&lang=js&"
import style0 from "./signCard.vue?vue&type=style&index=0&id=1d9b3f20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9b3f20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
